<template>
  <div>
    <a-form layout="inline">
      <a-row :gutter="12" class="searchManagement">
        <a-col :md="4" :sm="20" class="searchInput">
          <a-input placeholder="资产编号" v-model="searchModel.anln1" />
        </a-col>
        <a-col :md="4" :sm="20" class="searchInput">
          <a-input placeholder="资产名称" v-model="searchModel.anname" />
        </a-col>
        <a-col :md="4" :sm="24" class="searchInput">
          <a-button type="primary" @click="search" style="margin-right: 12px">查询</a-button>
          <a-button @click="clearSearch">重置</a-button>
        </a-col>
      </a-row>
    </a-form>
    <a-table
      id="tableDataTabs"
      bordered
      :columns="tableData.columns"
      :data-source="tableData.data"
      :pagination="tableData.pagination"
    >
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:;" @click="() => handleDownload(record)">下载</a>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="javascript:;" @click="() => handlePreview(record)">预览</a>
      </template>
    </a-table>
  </div>
</template>
<script>
export default {
  data () {
    return {
      tableData: {
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => {
              return index + 1
            },
            width: 50
          },
          {
            title: '文件名称',
            dataIndex: 'name',
            align: 'left'
          },
          {
            title: '文件分类',
            dataIndex: 'class',
            align: 'left'
          },
          {
            title: '上传人员',
            dataIndex: 'person',
            align: 'left'
          },
          {
            title: '上传时间',
            dataIndex: 'time',
            align: 'left'
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            },
            align: 'left'
          }
        ],
        data: [],
        pagination: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '40', '9999'],
          showSizeChanger: true,
          showQuickJumper: true
        }
      },
      analogData: [],
      searchModel: {}
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      for (let i = 0; i < 99; i++) {
        this.analogData.push(
          {
            id: 1 + `a${i}`,
            name: '文件1',
            class: '图纸',
            person: '张三',
            time: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '文件2',
            class: '图纸',
            person: '张三',
            time: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '文件3',
            class: '工程文件',
            person: '张三',
            time: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '文件4',
            class: '工程文件',
            person: '张三',
            time: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '文件5',
            class: '流程文件',
            person: '张三',
            time: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '文件6',
            class: '流程文件',
            person: '张三',
            time: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '文件7',
            class: '其他类型',
            person: '张三',
            time: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '文件8',
            class: '其他类型',
            person: '张三',
            time: '2022-11-11 14;23:23'
          }
        )
      }
      this.tableData.data = this.analogData
    },
    // 查询
    search () {
      console.log(this.searchModel)
    },
    clearSearch () {
      this.searchModel = {}
      console.log(this.searchModel)
    },
    // 文件下载
    handleDownload () {},
    // 文件预览
    handlePreview () {}
  }
}
</script>

<style lang="less" scoped>
.table {
  margin-left: -1px;
  margin-right: -1px;
  /deep/.ant-table-thead > tr > th {
    background: #E7F4FF !important;
    //background: rgba(8, 64, 159, 0.1);
  }
  /deep/ .ant-table-tbody > tr > td {
    padding: 10px;
  }
}
.searchManagement {
  margin: 0 !important;
  .searchInput {
    padding: 10px 0 10px 12px !important;
  }
}
/deep/.ant-table-placeholder {
  position: relative !important;
}
#tableDataTabs  {
  /deep/.ant-spin-nested-loading {
    >.ant-spin-container {
      .ant-table-bordered {
        .ant-table-header > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-thead > tr > th{
          border-right: 1px solid #e8e8e8;
        }
        .ant-table-body > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr > td{
          border-right: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr.ant-table-row-selected td{
          background-color: rgba(225, 225, 225, 0);
        }
        .ant-table-footer{
          border: none !important;
        }
      }
    }
  }
}
</style>
